import JsIcon from "./../../../../assets/icons/editor-files/languages/js.svg?react";
import JsxIcon from "./../../../../assets/icons/editor-files/languages/tsx.svg?react";
import TsIcon from "./../../../../assets/icons/editor-files/languages/ts.svg?react";
import CssIcon from "./../../../../assets/icons/editor-files/languages/css.svg?react";
import HtmlIcon from "./../../../../assets/icons/editor-files/languages/html.svg?react";
import JsonIcon from "./../../../../assets/icons/editor-files/languages/json.svg?react";
import SolidityIcon from "./../../../../assets/icons/editor-files/languages/solidity.svg?react";
import PlaintextIcon from "./../../../../assets/icons/editor-files/languages/plaintext.svg?react";
import SvgIcon from "./../../../../assets/icons/editor-files/languages/svg.svg?react";
import DockerIcon from "./../../../../assets/icons/editor-files/languages/docker.svg?react";
import PythonIcon from "./../../../../assets/icons/editor-files/languages/python.svg?react";
import JavaIcon from "./../../../../assets/icons/editor-files/languages/java.svg?react";
import GoIcon from "./../../../../assets/icons/editor-files/languages/go.svg?react";
import RubyIcon from "./../../../../assets/icons/editor-files/languages/ruby.svg?react";
import PhpIcon from "./../../../../assets/icons/editor-files/languages/php.svg?react";
import ShellIcon from "./../../../../assets/icons/editor-files/languages/shell.svg?react";
import SqlIcon from "./../../../../assets/icons/editor-files/languages/sql.svg?react";
import KotlinIcon from "./../../../../assets/icons/editor-files/languages/kotlin.svg?react";
import SassIcon from "./../../../../assets/icons/editor-files/languages/sass.svg?react";
import ScssIcon from "./../../../../assets/icons/editor-files/languages/scss.svg?react";
import PerlIcon from "./../../../../assets/icons/editor-files/languages/perl.svg?react";
import NginxIcon from "./../../../../assets/icons/editor-files/languages/nginx.svg?react";
import PgsqlIcon from "./../../../../assets/icons/editor-files/languages/pgsql.svg?react";
import YamlIcon from "./../../../../assets/icons/editor-files/languages/yaml.svg?react";
import CIcon from "./../../../../assets/icons/editor-files/languages/c.svg?react";
import CppIcon from "./../../../../assets/icons/editor-files/languages/cpp.svg?react";
import CsharpIcon from "./../../../../assets/icons/editor-files/languages/csharp.svg?react";
import DatabaseIcon from "./../../../../assets/icons/editor-files/languages/db.svg?react";
import GitIcon from "./../../../../assets/icons/editor-files/languages/git.svg?react";
import GitLabIcon from "./../../../../assets/icons/editor-files/languages/gitlab.svg?react";
import RustIcon from "./../../../../assets/icons/editor-files/languages/rust.svg?react";
import SqliteIcon from "./../../../../assets/icons/editor-files/languages/sqlite.svg?react";
import VueIcon from "./../../../../assets/icons/editor-files/languages/vue.svg?react";
import DjangoIcon from "./../../../../assets/icons/editor-files/languages/django.svg?react";
import { DappFile } from "./contexts/DappFilesContext";

const specialFilenames: Array<string> = [
  "dockerfile",
  "Dockerfile",
  "DockerFile",
  "gitignore",
  "gitkeep",
];

export const getFileType = (path: string): string | undefined => {
  const filename = path.split("/").pop();
  const filenameArr = filename?.split(".").filter(Boolean);

  if (!filenameArr) return undefined;

  const fileName = filenameArr[0];
  const extension = filenameArr[1];

  return specialFilenames.includes(fileName) ? fileName : extension;
};

export const getLanguageFromFilename = (path: string): string => {
  const fileType = getFileType(path);

  switch (fileType) {
    case "js":
    case "jsx":
      return "javascript";
    case "ts":
    case "tsx":
      return "typescript";
    case "css":
      return "css";
    case "html":
    case "svg":
      return "html";
    case "json":
      return "json";
    case "sol":
      return "sol";
    case "py":
      return "python";
    case "java":
      return "java";
    case "go":
      return "go";
    case "rb":
      return "ruby";
    case "php":
      return "php";
    case "sh":
    case "bash":
      return "shellscript";
    case "sql":
      return "sql";
    case "kt":
    case "kts":
      return "kotlin";
    case "sass":
      return "scss";
    case "scss":
      return "scss";
    case "pl":
    case "pm":
      return "perl";
    // case "conf":
    //   return "nginx";
    case "pgsql":
      return "pgsql";
    case "yaml":
    case "yml":
      return "yaml";
    case "c":
      return "c";
    case "cpp":
    case "cc":
    case "cxx":
    case "h":
    case "hpp":
      return "cpp";
    case "cs":
      return "csharp";
    // case "db":
    //   return "database";
    // case "git":
    //   return "git";
    // case "gitlab-ci.yml":
    //   return "gitlab";
    case "rs":
      return "rust";
    case "sqlite":
      return "sqlite";
    case "vue":
      return "vue";
    default:
      return "plaintext";
  }
};

export const getFileIcon = (path: string): React.ReactNode => {
  const fileType = getFileType(path);

  if (!fileType) {
    return (
      <PlaintextIcon className="w-3 h-3 flex-shrink-0 dark:text-slate-300" />
    );
  }

  switch (fileType) {
    case "js":
      return <JsIcon className="w-4 h-4 flex-shrink-0" />;
    case "jsx":
      return <JsxIcon className="w-4 h-4 flex-shrink-0" />;
    case "ts":
      return <TsIcon className="w-4 h-4 flex-shrink-0" />;
    case "tsx":
      return <JsxIcon className="w-4 h-4 flex-shrink-0" />;
    case "css":
      return <CssIcon className="w-4 h-4 flex-shrink-0" />;
    case "html":
      return <HtmlIcon className="w-4 h-4 flex-shrink-0" />;
    case "json":
      return <JsonIcon className="w-4 h-4 flex-shrink-0" />;
    case "sol":
      return <SolidityIcon className="w-4 h-4 flex-shrink-0" />;
    case "svg":
      return <SvgIcon className="w-3 h-3 flex-shrink-0" />;
    case "py":
      return <PythonIcon className="w-3 h-3 flex-shrink-0" />;
    case "java":
      return <JavaIcon className="w-3 h-3 flex-shrink-0" />;
    case "go":
      return <GoIcon className="w-3 h-3 flex-shrink-0" />;
    case "rb":
      return <RubyIcon className="w-3 h-3 flex-shrink-0" />;
    case "php":
      return <PhpIcon className="w-3 h-3 flex-shrink-0" />;
    case "sh":
    case "bash":
      return <ShellIcon className="w-3 h-3 flex-shrink-0" />;
    case "sql":
      return <SqlIcon className="w-3 h-3 flex-shrink-0" />;
    case "kt":
    case "kts":
      return <KotlinIcon className="w-3 h-3 flex-shrink-0" />;
    case "sass":
      return <SassIcon className="w-3 h-3 flex-shrink-0" />;
    case "scss":
      return <ScssIcon className="w-3 h-3 flex-shrink-0" />;
    case "pl":
    case "pm":
      return <PerlIcon className="w-3 h-3 flex-shrink-0" />;
    case "conf":
      return <NginxIcon className="w-3 h-3 flex-shrink-0" />;
    case "pgsql":
      return <PgsqlIcon className="w-3 h-3 flex-shrink-0" />;
    case "yaml":
    case "yml":
      return <YamlIcon className="w-3 h-3 flex-shrink-0" />;
    case "c":
      return <CIcon className="w-3 h-3 flex-shrink-0" />;
    case "cpp":
    case "cc":
    case "cxx":
    case "h":
    case "hpp":
      return <CppIcon className="w-3 h-3 flex-shrink-0" />;
    case "cs":
      return <CsharpIcon className="w-3 h-3 flex-shrink-0" />;
    case "db":
      return <DatabaseIcon className="w-3 h-3 flex-shrink-0" />;
    case "git":
      return <GitIcon className="w-3 h-3 flex-shrink-0" />;
    // case "gitlab-ci.yml":
    //   return <GitLabIcon className="w-3 h-3 flex-shrink-0" />;
    case "rs":
      return <RustIcon className="w-3 h-3 flex-shrink-0" />;
    case "sqlite":
      return <SqliteIcon className="w-3 h-3 flex-shrink-0" />;
    case "vue":
      return <VueIcon className="w-3 h-3 flex-shrink-0" />;
    case "django":
      return <DjangoIcon className="w-3 h-3 flex-shrink-0" />;
    case "dockerfile":
    case "Dockerfile":
    case "DockerFile":
      return <DockerIcon className="w-3 h-3 flex-shrink-0" />;

    default:
      return (
        <PlaintextIcon className="w-4 h-4 flex-shrink-0 dark:text-slate-300" />
      );
  }
};

export function getFileName(filePath: string | null | undefined): string {
  if (!filePath) return "";

  const sanitizedPath = filePath.replace(/^\/|\/$/g, "");
  const sanitizedPathArr = sanitizedPath.split("/").filter(Boolean);
  if (sanitizedPathArr.length < 1) return "";
  const fileName = sanitizedPathArr[sanitizedPathArr.length - 1];
  return fileName;
}

export function getDirectoryPath(file: DappFile | null | undefined): string {
  if (!file) return "";
  if (file.isDirectory) return file.path.replace(/^\/|\/$/g, "");
  const sanitizedPath = file.path.replace(/^\/|\/$/g, "");
  const sanitizedPathArr = sanitizedPath.split("/").filter(Boolean);
  if (sanitizedPathArr.length < 1) return "";
  const dirArr = sanitizedPathArr.slice(0, sanitizedPathArr.length - 1);
  return dirArr.join("/");
}

export function reduceFileName(fileName: string, maxLength: number = 30) {
  if (fileName.length <= maxLength) {
    return fileName;
  }

  const extensionIndex = fileName.lastIndexOf(".");
  const hasExtension = extensionIndex > 0;

  const extension = hasExtension ? fileName.slice(extensionIndex) : "";
  const baseName = hasExtension ? fileName.slice(0, extensionIndex) : fileName;

  const visibleChars = maxLength - 3 - extension.length;

  if (visibleChars <= 0) {
    // If maxLength is too small to show meaningful characters
    return fileName.slice(0, maxLength - 3) + "...";
  }

  const startChars = Math.ceil(visibleChars / 2);
  const endChars = Math.floor(visibleChars / 2);

  return (
    baseName.slice(0, startChars) +
    "..." +
    baseName.slice(-endChars) +
    extension
  );
}
